import { Component, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ArticlesServices } from '../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ArticleViewPage } from '../articles-view/article-view';
import { ArticlesCreateTypePage } from '../articles-create/articles-create-type/articles-create-type';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ArticlesUpdatePricesPage } from '../articles-update-prices/articles-update-prices';
import { ProductsServices } from '../../products/services';
import { DishServices } from '../../dish/services';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import * as moment from 'moment';

/**
 * Generated class for the ArticlesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-articles-list',
  templateUrl: 'articles-list.html',
})
export class ArticlesListPage {
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'pvp', dir: 'asc' },
    { prop: 'beneficio', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public articlesServices: ArticlesServices,
    public http: HttpClient,
    public productsServices: ProductsServices,
    public dishServices: DishServices,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController) {
    this.articlesServices.articles_searchbar_text = '';
    this.globals.GAtrackView('Articles', 'Articles - List', this.globals.restaurant.email, 'View', 'List articles', 'Articles', '');
    if (this.globals.checkLimitsByLicense('dishes', 'analitycs')) {//Si analitycs activo para la version
      //analitics
      this.analyticsGetMostSoldDish();
      this.analyticsGetTotalNumberDishesSold();
      this.analyticsGetTotalDishesSoldToday();
      this.initGetFoodcostCategoryAllergens();
    } else {
      this.loader_most_sold_dish = false;
      this.loader_total_dishes_sold = false;
      this.loader_dishes_sold_today = false;
    }
  }

  ionViewWillEnter() {
    if (this.globals.restaurant.plg_articles_starter == undefined || this.globals.restaurant.plg_articles_starter == false) {
      this.globals.restaurant.plg_articles_starter = true;
      //save octupus_reservas_list
      this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_articles_starter: true
      });
      //update hubspot contact
      this.globals.updateERPNextCustomer();
    }
    if (this.articlesServices.articles_array_tmp.length > 0) {
      setTimeout(() => {
        this.articlesServices.getPagesArticles(true);
      }, 1500);
    } else {
      this.articlesServices.getPagesArticles(false);
    }
    this.dishServices.image_url_dish_view = null;
    this.productsServices.image_url_product_view = null;
  }

  //Analitica informació allergens, categories i foodcost
  async initGetFoodcostCategoryAllergens() {
    // Optimización: ejecutar las 3 peticiones en paralelo en lugar de secuencialmente
    Promise.all([
      this.analyticsGetCategoryTotal(),
      this.analyticsGetDishesFoodcostPercent(),
      this.analyticsGetDishesAllergensTotal()
    ]).catch(error => {
      console.error('Error en initGetFoodcostCategoryAllergens:', error);
    });
  }

  newArticle() {
    if (this.articlesServices.list_dishes_products_array.length >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.navCtrl.push(ArticlesCreateTypePage);
    }
  }

  importDishes(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  activeAllElementsPOS() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-activar-tpv'),
      message: this.translate.instant('articulos-activar-en-tpv'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            for (let element of this.articlesServices.list_dishes_products_array) {
              if (element.tpv_active == false) {
                element.tpv_active = true;
                if (element.type === 'dish') {
                  this.articlesServices.firestore.collection('dish').doc(element.UID).update({
                    tpv_active: true
                  });
                } else {
                  this.articlesServices.firestore.collection('products').doc(element.UID).update({
                    tpv_active: true
                  });
                }
              }
            }
            this.articlesServices.articles_array_filtered = this.articlesServices.list_dishes_products_array;
            this.globals.launchToast(this.translate.instant('articulos-todos-activados'), 3000, 'top');
          }
        }
      ]
    });
    alert.present();
  }

  clickElement(event) {
    if (event.type == 'click' && event.column.name !== 'duplicate') {
      if (event.row._active) {
        this.navCtrl.push(ArticleViewPage, {
          article_type: event.row.type,
          article_uid: event.row.UID
        });
      } else {
        this.navCtrl.push(AddonsTriggerVersionProPage);
      }
    }
  }

  duplicateArticle(article) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('articles-duplicar-articulo'),
      message: this.translate.instant('articles-seguro-quieres-duplicar-articulo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.articlesServices.duplicateArticle(article);
          }
        }
      ]
    });
    alert.present();
  }

  updatePrices() {
    if (this.globals.checkLimitsByLicense('dishes', 'update_prices')) {
      this.navCtrl.push(ArticlesUpdatePricesPage, {
        elements: this.articlesServices.list_dishes_products_array
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  profitFoodCost(price, foodcost) {
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    if (price != 0 && foodcost != 0) {
      return parseInt((100 - this.globals.regla3(price, foodcost)).toFixed(0));
    } else {
      return 0;
    }
  }

  getRowClass(row) {
    return {
      'not-active': row._active === false
    };
  }

  getColor(value: number): string {
    if (value > 66) {
      return '#00b19d';
    } else if (value < 33) {
      return '#ef5350';
    } else {
      return '#fa0';
    }
  }

  getImage(element) {
    const imageParts = element.image.split('/');
    let url: string;
    if (imageParts.length > 1) {
      if (imageParts.length === 3) {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[1])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      } else {
        url = `https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/${encodeURIComponent(imageParts[0])}%2F${encodeURIComponent(imageParts[imageParts.length - 1])}?alt=media`;
      }
    } else {
      url = './assets/images/subir_imagen_v2_Mesa_de_trabajo_1_copia_7.png';
    }
    return url;
  }

  onSort(event) {
    var dishes_array = this.articlesServices.articles_array_filtered;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          dishes_array.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
        } else {
          dishes_array.sort((a, b) => this.globals.nameLangSelectDish(b).localeCompare(this.globals.nameLangSelectDish(a)));
        }
        break;
      case 'pvp':
        if (event.newValue == 'asc') {
          dishes_array.sort((a, b) => a.price - b.price);
        } else {
          dishes_array.sort((a, b) => b.price - a.price);
        }
        break;
      case 'beneficio':
        if (event.newValue == 'asc') {
          dishes_array.sort((a, b) => this.profitFoodCost(a.price, a.foodcost_static / a.foodcost_parts) - this.profitFoodCost(b.price, b.foodcost_static / b.foodcost_parts));
        } else {
          dishes_array.sort((a, b) => this.profitFoodCost(b.price, b.foodcost_static / b.foodcost_parts) - this.profitFoodCost(a.price, a.foodcost_static / a.foodcost_parts));
        }
        break;
    }

    this.articlesServices.articles_array_filtered = dishes_array;
  }

  /********************************************************/
  /*                      ANALITICS                       */
  /********************************************************/
  mostDishSale: any = '';
  loader_most_sold_dish: boolean = true;
  async analyticsGetMostSoldDish() {
    this.loader_most_sold_dish = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_most_sold_dish', params, {})
      .subscribe(res => {
        this.mostDishSale = res;
        if (this.mostDishSale != null) {
          this.mostDishSale = res[0];
        } else {
          this.mostDishSale = this.translate.instant('general-faltan-datos');
        }
        this.loader_most_sold_dish = false;
      });
  }

  loader_total_dishes_sold: boolean = true;
  total_dishes_sold: any = '';
  async analyticsGetTotalNumberDishesSold() {
    this.loader_total_dishes_sold = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    //enviar post la peticion y devuelve el total de platos vendidos
    this.http.post(this.globals.analytics_path + 'bidish/get_total_dishes_sold', params, {})
      .subscribe(res => {
        this.total_dishes_sold = res;
        this.loader_total_dishes_sold = false;
      });
  }

  loader_dishes_sold_today: boolean = true;
  dishes_sold_today: any = '';
  async analyticsGetTotalDishesSoldToday() {
    this.loader_dishes_sold_today = true;

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));
    this.http.post(this.globals.analytics_path + 'analytics/elements_total_sold', params, {})
      .subscribe(async response => {
        this.dishes_sold_today = response['total_elements_sold'];
        this.loader_dishes_sold_today = false;
      });
  }

  category_desplegado: any[] = [];
  dishes_with_category = 0;
  dishes_without_category = 0;
  total_plats = 0;
  category_cinc_primers: any[] = [];
  loader_categories: boolean = true;
  async analyticsGetCategoryTotal() {
    this.loader_categories = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bidish/get_category_total', params, {})
      .subscribe(async res => {
        // console.log('Respuesta de categorías:', res);

        // Procesar todas las categorías
        const allCategories = [
          ...(res['category_sin_desplegar'] || []),
          ...(res['category'] || [])
        ];

        // Asignar UID a cada categoría
        allCategories.forEach(cat => {
          cat.UID = cat.UID || cat.id || cat._id;
        });

        // Ordenar las categorías
        allCategories.sort((a, b) => {
          const aName = (a.name || '').toLowerCase();
          const bName = (b.name || '').toLowerCase();
          return aName.localeCompare(bName);
        });

        // Tomar los 5 primeros para category_cinc_primers
        this.category_cinc_primers = allCategories.slice(0, 5);

        // El resto van a category_desplegado
        this.category_desplegado = allCategories.slice(5);

        // console.log('Categorías procesadas:', {
        //   cinc_primers: this.category_cinc_primers,
        //   desplegado: this.category_desplegado
        // });

        this.dishes_with_category = res['amb_categoria'];
        this.dishes_without_category = res['sense_categoria'];
        this.total_plats = res['total_plats'];

        this.loader_categories = false;
      });
  }


  average_foodcost_percent = 0;
  dishes_without_price = 0;
  dishes_without_foodcost = 0;
  loader_foodcost: boolean = true;
  async analyticsGetDishesFoodcostPercent() {
    this.loader_foodcost = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_dishes_foodcost_percentatge', params, {})
      .subscribe(res => {
        this.average_foodcost_percent = Math.round(res['percentatge_foodcost']);
        this.dishes_without_price = res['plats_sense_price'];
        this.dishes_without_foodcost = res['plats_sense_foodcost'];
        this.loader_foodcost = false;
      });
  }

  //Allergens
  allergens_cinc_primers = [];
  allergens_tots = [];
  number_of_dishes_with_allergens = 0;
  number_of_dishes_without_allergens = 0;
  loader_allergens: boolean = true;
  async analyticsGetDishesAllergensTotal() {
    this.loader_allergens = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_dishes_allergens_total', params, {})
      .subscribe(res => {
        //Convertimos la id del allergeno en su nombre
        for (let allergen_id of res['allergens']) {
          this.allergens_cinc_primers.push({
            "name": this.globals.getAllergenName(allergen_id.id_allergen).replace('*', ''),
            "total": allergen_id.total,
          });
        }
        //Convertimos la id del allergeno en su nombre
        for (let aller_id of res['allergens_tot']) {
          this.allergens_tots.push({
            "name": this.globals.getAllergenName(aller_id.id_allergen).replace('*', ''),
            "total": aller_id.total,
          });
        }
        this.number_of_dishes_with_allergens = res['dishes_with_allergens'];
        this.number_of_dishes_without_allergens = res['dishes_without_allergens'];
        this.loader_allergens = false;
      });
  }

  //Funció per a mostrar més categories
  show_all_categories = false;
  change_show_categories() {
    if (this.show_all_categories) {
      this.show_all_categories = false;
    } else {
      this.show_all_categories = true;
    }
  }

  //Funció per a mostrar més allergens
  show_all_allergens = false;
  change_show_allergens() {
    if (this.show_all_allergens) {
      this.show_all_allergens = false;
    } else {
      this.show_all_allergens = true;
    }
  }

  //Clic para buscar la categoria
  clic_buscar_categoria(categoria) {
    this.articlesServices.articles_searchbar_text = categoria;
    this.articlesServices.articleSearch(this.articlesServices.articles_searchbar_text);
  }

  styleIcon(total, nombre_cat) {
    let styles = {
      'width': this.globals.regla3(total, nombre_cat) + '%',
    };
    return styles;
  }

  stateColCss() {
    if (this.globals.platform_width === 'mobile') {
      let cssClasses = {
        'col-6': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'col-auto': true
      }
      return cssClasses;
    }
  }

  changeValue(type) {
    if (type == 'basic') {
      this.articlesServices.show_articles_basic = !this.articlesServices.show_articles_basic;
    } else {
      this.articlesServices.show_articles_foodcost = !this.articlesServices.show_articles_foodcost;
    }
    this.articlesServices.filter(false);
  }

}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-list/articles-list.ts